const DEFAULT_PER_PAGE_OPTIONS = [10, 20, 40, 60, 80, 100];
const PER_PAGE_SKU = 60;
const PER_PAGE_BILLING = 60;
const PER_PAGE_NOTIFICATION = 60;
const TOP_BAR_NOTIFICATION = 5;

export { DEFAULT_PER_PAGE_OPTIONS, PER_PAGE_BILLING, PER_PAGE_SKU, PER_PAGE_NOTIFICATION, TOP_BAR_NOTIFICATION };